export function deepToPairs(obj, path = "", result = []) {
  if (typeof obj === "object" && obj !== null) {
    if (Array.isArray(obj)) {
      obj.forEach((value, index) => {
        deepToPairs(value, `${path}-${index}`, result);
      });
    } else {
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          deepToPairs(obj[key], path ? `${path}-${key}` : key, result);
        }
      }
    }
  } else {
    result.push([path, obj]);
  }

  return result;
}
